import React, { useEffect, useState } from 'react';
import { GoalBase } from '../../Admin/Commons/GoalBase';
import { 
    ConnectCapsWebSocket, 
    DisconnectCapsWebSocket, 
    SelectCapAficionadoBL 
} from '../../../utilities/BL/Caps';


/**
 * COMPONENTE AFICIONADO: ¿DÓNDE QUEDÓ LA BOLITA?
 */
const Caps = () => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [connectionStatus, setConnectionStatus] = useState('idle');
    const [isSending, setIsSending] = useState(false);

    const [matchState, setMatchState] = useState({
        phase: 'WAITING', 
        revealData: null
    });

    useEffect(() => {
        if (matchState.phase === 'WAITING' || matchState.phase === 'SHUFFLING') {
            setIsSending(false); 
        }
    }, [matchState.phase]);

    useEffect(() => {
        if (!isPlaying) return;

        const handleIncomingMessage = (msg) => {
            const type = (msg?.type || '').toLowerCase();
            const payload = msg?.payload || {};

            if (type === 'kicked_out') {
                DisconnectCapsWebSocket();
                setIsPlaying(false);
                setTimeout(() => {
                    alert("Tu sesión fue cerrada o el juego ha terminado.");
                }, 100);
                return;
            }

            if (type === 'caps.progress') {
                setMatchState(prev => ({
                    ...prev,
                    phase: payload.phase,
                    revealData: payload.revealData
                }));
            } else if (type === 'caps.reset') {
                setMatchState({ phase: 'WAITING', revealData: null });
            }
        };

        ConnectCapsWebSocket(handleIncomingMessage, setConnectionStatus, () => {});

        return () => {
            DisconnectCapsWebSocket();
        };
    }, [isPlaying]);

    const handleSelectCap = async (capId) => {
        if (matchState.phase !== 'SELECTING' || isSending) return;
        
        setIsSending(true);
        const res = await SelectCapAficionadoBL(capId);
        if (!res.success) {
            alert("Error al enviar tu selección. Intenta de nuevo.");
            setIsSending(false);
        }
    };

    // PANTALLA 1: INGRESO AL JUEGO
    if (!isPlaying) {
        return (
            <GoalBase classNameApplied={'Fan__Goal__Header'}>
                <div className="caps-fan__intro d-flex flex-column align-items-center justify-content-center">
                    <img src="/img/page/xolos-five.png" alt="Logo" className="caps-fan__intro-logo" />
                    <h1 className="fw-bold mb-4">Encuentra el balón</h1>
                    <p className="mb-5">Sigue la gorra ganadora y prepárate para elegir</p>
                    <button className="btn btn-warning btn-lg fw-bold w-100 shadow caps-fan__intro-btn" onClick={() => setIsPlaying(true)}>
                        <i className="bi bi-controller"></i> Entrar a jugar
                    </button>
                    <p className="caps-fan__intro-footer">Hecho con ♥ por Five Digital Minds</p>
                </div>
            </GoalBase>
        );
    }

    // PANTALLA 2: CONTROLES DEL JUEGO
    return (
        <div className="caps-fan d-flex flex-column">
            
            {/* CABECERA */}
            <header className="caps-fan__header p-3 d-flex justify-content-between align-items-center">
                <button 
                    className="btn btn-danger btn-sm fw-bold" 
                    onClick={() => { DisconnectCapsWebSocket(); setIsPlaying(false); }}
                >
                    <i className="bi bi-box-arrow-right"></i> Salir
                </button>

                <div className="text-end">
                    <span className={`badge ${connectionStatus === 'connected' ? 'bg-success' : 'bg-warning'} small d-block`}>
                        {connectionStatus === 'connected' ? 'Conectado' : 'Conectando...'}
                    </span>
                </div>
            </header>

            {/* ZONA CENTRAL DE MENSAJES Y BOTONES */}
            <div className="flex-grow-1 d-flex flex-column align-items-center justify-content-center p-4">
                
                {matchState.phase === 'WAITING' && (
                    <div className="text-center animation-fade-in">
                        <img src="/img/page/xolos-five.png" alt="Logo" className="caps-fan__intro-logo" style={{ width: '100%', maxWidth: '350px' }} />
                        <p className='mb-0'><i className="bi bi-eye text-warning mb-3 caps-fan__icon"></i></p>
                        <h2 className="text-white fw-bold">¡Atención a la pantalla!</h2>
                        <p className="text-white-50 fs-5">Fíjate bien dónde esconden el premio</p>
                    </div>
                )}

                {matchState.phase === 'SHUFFLING' && (
                    <div className="text-center animation-pulse">
                        <img src="/img/page/xolos-five.png" alt="Logo" className="caps-fan__intro-logo" style={{ width: '100%', maxWidth: '350px' }} />
                        <p className='mb-0'><i className="bi bi-shuffle text-info mb-3 caps-fan__icon"></i></p>
                        <h1 className="text-white fw-bold">¡MEZCLANDO!</h1>
                        <p className="text-white-50 fs-5">No le quites los ojos de encima...</p>
                    </div>
                )}

                {matchState.phase === 'SELECTING' && (
                    <div className="text-center w-100 animation-fade-in">
                        <img src="/img/page/xolos-five.png" alt="Logo" className="caps-fan__intro-logo" style={{ width: '100%', maxWidth: '350px' }} />
                        <p className="text-white fw-bold mb-4">ELIGE UNA OPCIÓN</p>
                        <div className="d-flex flex-column gap-3 w-100">
                            {[1, 2, 3].map(id => (
                                <button 
                                    key={id}
                                    className="btn btn-outline-light btn-lg fw-bold py-3 caps-fan__btn d-flex flex-column align-items-center"
                                    onClick={() => handleSelectCap(id)}
                                    disabled={isSending}
                                >
                                    <img src='/img/games/caps/cap.png' alt='Gorra' style={{ width: '50px' }} />
                                    Gorra {id}
                                </button>
                            ))}
                        </div>
                    </div>
                )}

                {matchState.phase === 'REVEAL_MODAL' && matchState.revealData && (
                    <div className="text-center animation-fade-in">
                        <div className={`rounded-circle d-inline-flex align-items-center justify-content-center mb-4 caps-fan__reveal-icon-wrapper ${matchState.revealData.isWinner ? 'bg-success' : 'bg-danger'}`}>
                            <i className={`bi ${matchState.revealData.isWinner ? 'bi-trophy-fill' : 'bi-x-lg'} text-white caps-fan__reveal-icon`}></i>
                        </div>
                        <h2 className="text-white fw-bold mb-3">{matchState.revealData.text}</h2>
                        <p className="text-white-50">Voltea a ver la pantalla</p>
                    </div>
                )}
            </div>
            
        </div>
    );
};

export { Caps };